module.exports = __webpack_public_path__ + "img/blue_121.006e8b80.png";